/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Concierge_ActiveInputs */

const en_ai_concierge_active = /** @type {(inputs: Ai_Concierge_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Concierge Active`)
};

const es_ai_concierge_active = /** @type {(inputs: Ai_Concierge_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conserje IA activo`)
};

const fr_ai_concierge_active = /** @type {(inputs: Ai_Concierge_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concierge IA actif`)
};

const de_ai_concierge_active = /** @type {(inputs: Ai_Concierge_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Concierge Aktiv`)
};

const ja_ai_concierge_active = /** @type {(inputs: Ai_Concierge_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIコンシェルジュがアクティブです`)
};

const zh_ai_concierge_active = /** @type {(inputs: Ai_Concierge_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 礼宾客服已激活`)
};

const ar_ai_concierge_active = /** @type {(inputs: Ai_Concierge_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المساعد الذكي نشط`)
};

const id_ai_concierge_active = /** @type {(inputs: Ai_Concierge_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pramutamu AI Aktif`)
};

const it_ai_concierge_active = /** @type {(inputs: Ai_Concierge_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concierge IA Attivo`)
};

const ru_ai_concierge_active = /** @type {(inputs: Ai_Concierge_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ИИ-Консьерж Активен`)
};

const pt_ai_concierge_active = /** @type {(inputs: Ai_Concierge_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concierge IA Ativo`)
};

const ko_ai_concierge_active = /** @type {(inputs: Ai_Concierge_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 컨시어지 활성`)
};

/**
* | output |
* | --- |
* | "AI Concierge Active" |
*
* @param {Ai_Concierge_ActiveInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ai_concierge_active = /** @type {((inputs?: Ai_Concierge_ActiveInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Concierge_ActiveInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ai_concierge_active(inputs)
	if (locale === "es") return es_ai_concierge_active(inputs)
	if (locale === "fr") return fr_ai_concierge_active(inputs)
	if (locale === "de") return de_ai_concierge_active(inputs)
	if (locale === "ja") return ja_ai_concierge_active(inputs)
	if (locale === "zh") return zh_ai_concierge_active(inputs)
	if (locale === "ar") return ar_ai_concierge_active(inputs)
	if (locale === "id") return id_ai_concierge_active(inputs)
	if (locale === "it") return it_ai_concierge_active(inputs)
	if (locale === "ru") return ru_ai_concierge_active(inputs)
	if (locale === "pt") return pt_ai_concierge_active(inputs)
	return ko_ai_concierge_active(inputs)
});